export default __webpack_public_path__ + "static/xverse-00208ac06dc243bd3eb14c59aff04261.svg";